const CHANGE = '[workings]change';			// modify workings (with diff comparison)
const ADD = '[workings]add';						// add to end of workings (without diff)

export {CHANGE, ADD}